import { render, staticRenderFns } from "./PK.vue?vue&type=template&id=a5cefe10&scoped=true"
import script from "./PK.vue?vue&type=script&lang=js"
export * from "./PK.vue?vue&type=script&lang=js"
import style0 from "./PK.vue?vue&type=style&index=0&id=a5cefe10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cefe10",
  null
  
)

export default component.exports